"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CryptoUtils = void 0;
var _core = _interopRequireDefault(require("crypto-js/core"));
var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));
var _sha = _interopRequireDefault(require("crypto-js/sha256"));
const UUID_V4_TEMPLATE = '10000000-1000-4000-8000-100000000000';
class CryptoUtils {
  static _randomWord() {
    return _core.default.lib.WordArray.random(1).words[0] ?? 0;
  }
  static generateUUIDv4() {
    const uuid = UUID_V4_TEMPLATE.replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise -- Crypto utility
    (+c ^ CryptoUtils._randomWord() & 15 >> +c / 4).toString(16));
    return uuid.replaceAll(/-/g, '');
  }
  static generateCodeVerifier() {
    return CryptoUtils.generateUUIDv4() + CryptoUtils.generateUUIDv4() + CryptoUtils.generateUUIDv4();
  }
  static generateCodeChallenge(codeVerifier) {
    const hashed = (0, _sha.default)(codeVerifier);
    return _encBase.default.stringify(hashed).replaceAll(/\+/g, '-').replaceAll(/\//g, '_')
    // eslint-disable-next-line no-div-regex -- Crypto utility
    .replaceAll(/=+$/g, '');
  }
}
exports.CryptoUtils = CryptoUtils;
